import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rtn-home-footer-appointment',
  templateUrl: './footer-appointment.component.html',
  styleUrls: ['./footer-appointment.component.scss']
})
export class FooterAppointmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
